var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3162_82675)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 12,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3162_82675)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9.90625,
    y: -4.95215,
    width: 26,
    height: 23.5238,
    rx: 11.7619,
    fill: "#FB3AFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3162_82675)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.1914,
    y: 35.2861,
    width: 26,
    height: 23.5238,
    rx: 11.7619,
    fill: "#288BFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3162_82675)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.0469,
    y: -0.620117,
    width: 26,
    height: 23.5238,
    rx: 11.7619,
    fill: "#28FFE5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3162_82675)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.57031,
    y: 34.0479,
    width: 26,
    height: 23.5238,
    rx: 11.7619,
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.7118 24.8483H14.5442L16.9991 11.9013H14.6198L11.6012 24.8483H9.62402L12.9876 9.90479H19.5323L16.7118 24.8483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6485 9.90479L26.5908 24.8483H24.3579L24.6191 21.6391H21.4433L20.5162 24.8483H18.2833L22.8536 9.90479H27.6485ZM24.1985 12.1831H25.4026L24.8019 19.6426H22.0309L23.4673 14.7676L24.1985 12.1831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1419 26.4721L32.0843 41.4156H29.8514L30.1125 38.2064H26.9368L26.0097 41.4156H23.7768L28.347 26.4721H33.1419ZM29.692 28.7503H30.896L30.2953 36.2099H27.5244L28.9607 31.3348L29.692 28.7503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.211 14.1306L32.668 11.7299L36.9406 11.7544L37.3063 9.90479H30.8268L28.0064 24.8483H34.4858L36.1963 15.6985L36.562 13.7264L32.211 14.1306ZM30.5396 23.011L31.8454 16.1027L33.9765 15.9434L32.6577 23.011H30.5396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3383 30.6979L37.7953 28.2971L42.0679 28.3216L42.4335 26.4721H35.9541L33.1337 41.4156H39.6131L41.3236 32.2657L41.6893 30.2937L37.3383 30.6979ZM35.6669 39.5783L36.9727 32.67L39.1038 32.5107L37.785 39.5783H35.6669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4864 28.4215H26.0664L26.6066 26.4721H21.9016L20.0723 32.9417H18.826L15.5468 26.4721H13.2715L14.1247 28.3537L16.2043 32.9417H14.3962L12.5655 39.5268H10.4013L10.0076 41.4762H14.1503L15.9201 34.9679H17.4231L20.1043 41.4762H22.3796L21.5263 39.5946L19.414 34.9981L21.6558 35.0065L23.4864 28.4215Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3162_82675",
    x: -49.3634,
    y: -44.4093,
    width: 104.914,
    height: 102.438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.7286,
    result: "effect1_foregroundBlur_3162_82675"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3162_82675",
    x: -7.26575,
    y: -4.17103,
    width: 104.914,
    height: 102.438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.7286,
    result: "effect1_foregroundBlur_3162_82675"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3162_82675",
    x: -5.41029,
    y: -40.0773,
    width: 104.914,
    height: 102.438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.7286,
    result: "effect1_foregroundBlur_3162_82675"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3162_82675",
    x: -45.0275,
    y: -5.40931,
    width: 104.914,
    height: 102.438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.7286,
    result: "effect1_foregroundBlur_3162_82675"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3162_82675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessLogo);
export default __webpack_public_path__ + "static/media/business-logo.90b30c1377c6fda3c764f212cd62ed9e.svg";
export { ForwardRef as ReactComponent };